import { css } from 'jimu-core';
import { colorUtils } from 'jimu-theme';
export const progressStyles = (props) => {
    var _a, _b, _c, _d;
    const theme = props.theme;
    const progressVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.progress;
    const propColor = (_b = props.color) !== null && _b !== void 0 ? _b : 'primary';
    const color = propColor === 'danger' ? 'error' : propColor;
    const type = (_c = props.type) !== null && _c !== void 0 ? _c : 'linear';
    const showProgress = (_d = props.showProgress) !== null && _d !== void 0 ? _d : false;
    const colorValue = colorUtils.getThemeColorNameColor(color, theme);
    const progressNumWidth = '2.5rem';
    return progressVars && type === 'linear'
        ? css `
    display: flex;
    min-width: ${progressNumWidth};
    overflow: hidden;
    font-size: ${progressVars.fontSize};
    align-items: center;
    .progress-bar-track {
      height: 2px;
      width: ${showProgress ? 'calc(100% - ' + progressNumWidth + ')' : '100%'};
      background-color: ${progressVars.bg};
      border-radius: ${progressVars.borderRadius};
    }
    .progress-bar {
      height: 100%;
      background-color: ${colorValue};
      border-radius: ${progressVars.borderRadius};
      transition: width 300ms ease;
    }
    .progress-bar-text {
      display: ${showProgress ? '' : 'none'};
      min-width: ${progressNumWidth};
      text-align: right;
      padding-left: 0.5rem;
    }
  `
        : css `
    display: inline-flex;
    .progress-circle-bg, .progress-circle-progress {
      fill: none;
    }
    .progress-circle-bg {
      stroke: ${progressVars.bg};
    }
    .progress-circle-progress {
      stroke: ${colorValue};
      transition: stroke-dashoffset 300ms ease;
    }
    .progress-circle-text {
      fill: ${theme.ref.palette.black};
      display: ${showProgress ? '' : 'none'};
    }
  `;
};
